import React, { useEffect, useContext } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import "../../styles/globals.css";
import "./QuestionnaireDonePage.css";

/**
 * 問診送信画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function QuestionnaireDonePage() {
  const { globalMedicalInstitutionName } = useContext(AppContext);

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {}, []);

  return (
    <div className="questionnaire-done">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      <div className="main-area">
        <div className="done-message-area">
          <CheckCircleOutlined className="done-message-icon" />
          <div className="done-message-label">問診を送信しました</div>
        </div>
        <div className="done-message-detail">
          ご回答ありがとうございました。
          <br />
          当日は予約した日時に当院までお越しください。
        </div>
      </div>
    </div>
  );
}

export default QuestionnaireDonePage;
